import {
    GET_NOTIFICATIONS_LOADING,
    GET_NOTIFICATIONS_SUCCESS,
    GET_NOTIFICATIONS_REJECT,
} from "../../actions/notifications/getAll";

import {
    GET_ROUTE_IMPORT_LOADING,
    GET_ROUTE_IMPORT_SUCCESS,
    GET_ROUTE_IMPORT_REJECT,
} from "../../actions/notifications/getAllRoutesImport";

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
    routesImport: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: [],
    }
}

const notificationsReducer = (state = stateInit, action) => {
    switch (action.type) {
        // ------------- GET ALL --------------------
        case GET_NOTIFICATIONS_LOADING: return {
            ...state,
            isLoading: true,
            isSuccess: false,
            isReject: false,
            data: [],
            error: {},
        }
        case GET_NOTIFICATIONS_SUCCESS: return {
            ...state,
            isLoading: false,
            isSuccess: true,
            isReject: false,
            error: {},
            ...action.payload,
        }
        case GET_NOTIFICATIONS_REJECT: return {
            ...state,
            isLoading: false,
            isSuccess: false,
            isReject: true,
            data: [],
            error: action.payload?.response?.data
        }

        case GET_ROUTE_IMPORT_LOADING: return {
            ...state,
            routesImport: {
                ...state.routesImport,
                isLoading: true,
                isSuccess: false,
                isReject: false,
                error: {},
            }
        }
        case GET_ROUTE_IMPORT_SUCCESS: return {
            ...state,
            routesImport: {
                ...state.routesImport,
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                data: action.payload?.data || [],
            }
        }
        case GET_ROUTE_IMPORT_REJECT: return {
            ...state,
            routesImport: {
                ...state.routesImport,
                isLoading: false,
                isSuccess: false,
                isReject: true,
                error: action.payload?.response?.data || {},
            }
        }

        default: return state;
    }
}

export default notificationsReducer